const prefix = '[Language]';

export class LoadLanguages {
    public static readonly type = `${prefix} Load Languages`;
}

export class SetCurrentLanguage {
    public static readonly type = `${prefix} Set Current Language`;
    constructor(public languageCode: string) {}
}

export class SetPreviouslySelectedLanguage {
    public static readonly type = `${prefix} Set Previously Selected Language`;
}
